import { useUserSubprofilesSelector } from "./useUserSubprofilesSelector";

export const useUserCurrentSubprofileSelector = () => {
  const { Data } = useUserSubprofilesSelector();
  return Data?.currentSubprofile;
};
